import { getModalStyles, TOOLBARS, BUTTON_TYPES, decorateComponentWithProps, getBottomToolbarModalStyles } from 'wix-rich-content-editor-common';
import VerticalEmbedInputModal from './VerticalEmbedInputModal.js';
import { modalContentStyles, contentTypeMap } from '../constants.js';
import getModalCustomStyles from './ModalCustomStyles.js';
import { MOBILE_FULL_SCREEN_CUSTOM_STYLE, DesktopFlyOutModalStyles, DesktopOverlayModalStyles } from 'wix-rich-content-ui-components';
import Product from '../icons/Product.js';
import Event from '../icons/Event.js';
import Booking from '../icons/Booking.js';
import 'prop-types';
import 'react';
import './VerticalEmbedInsertModal.js';
import 'wix-rich-content-plugin-commons';
import '../ItemsList-09cdb7f4.js';
import '../style-inject.es-746bb8ed.js';
import 'classnames';
import './itemsList/Item.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../convertDuration.js';
import 'lodash';
import '../types.js';
import 'wix-rich-content-common';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const createInsertButtons = ({
  t,
  settings,
  isMobile,
  locale,
  experiments = {}
}) => {
  var _a;
  const iconsMap = {
    product: Product,
    event: Event,
    booking: Booking
  };
  const useNewModal = (_a = experiments == null ? void 0 : experiments.newVideoVerticalAndSocialModals) == null ? void 0 : _a.enabled;
  const newModalCustomStyles = isMobile ? MOBILE_FULL_SCREEN_CUSTOM_STYLE : __spreadProps(__spreadValues({}, DesktopFlyOutModalStyles), { content: modalContentStyles });
  const customStyles = useNewModal ? newModalCustomStyles : getModalCustomStyles(isMobile);
  const modalStylesFn = useNewModal ? ({ buttonRef, toolbarName }) => {
    return getBottomToolbarModalStyles(
      buttonRef,
      {
        customStyles
      },
      toolbarName
    );
  } : void 0;
  const defaultModalStyles = getModalStyles({
    customStyles,
    fullScreen: !!useNewModal,
    isMobile
  });
  const newModalStyles = isMobile ? defaultModalStyles : void 0;
  const modalStyles = useNewModal ? newModalStyles : defaultModalStyles;
  const { exposeEmbedButtons = [], getIsVisiblePromise } = settings;
  const buttonsBaseProps = (type) => {
    const contentType = contentTypeMap[type];
    return {
      type: BUTTON_TYPES.MODAL,
      name: `${contentType}_InsertButton`,
      tooltip: t(`${contentType}Plugin_InsertButton_Tooltip`),
      getIcon: () => iconsMap[type],
      Icon: iconsMap[type],
      section: "BlockToolbar_Section_Embed_Wix",
      modalElement: decorateComponentWithProps(VerticalEmbedInputModal, __spreadProps(__spreadValues({}, settings), {
        locale,
        type,
        componentData: { type }
      })),
      isVisiblePromise: getIsVisiblePromise == null ? void 0 : getIsVisiblePromise(type, locale),
      modalStylesFn
    };
  };
  const toolbars = useNewModal ? [TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE] : [TOOLBARS.INSERT_PLUGIN, TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE];
  let verticalEmbedButtons = exposeEmbedButtons.map((verticalType) => __spreadProps(__spreadValues({}, buttonsBaseProps(verticalType)), {
    toolbars,
    modalStyles
  }));
  if (useNewModal) {
    const externalToolbarButtons = exposeEmbedButtons.map((verticalType) => __spreadProps(__spreadValues({}, buttonsBaseProps(verticalType)), {
      toolbars: [TOOLBARS.INSERT_PLUGIN],
      modalStyles: getModalStyles({
        customStyles: __spreadValues(__spreadValues({}, customStyles), DesktopOverlayModalStyles),
        fullScreen: isMobile,
        isMobile
      })
    }));
    verticalEmbedButtons = [...verticalEmbedButtons, ...externalToolbarButtons];
  }
  return verticalEmbedButtons;
};

export { createInsertButtons as default };
//# sourceMappingURL=insert-buttons.js.map
